// AlertService — migrated to the OpenAPI-generated client.
//
// getAlerts returned the raw axios `response` (caller reads `res.data`), so we return `{data}`
// with the parsed JSON body. Auth/timezone come from configureApi's interceptor.
//
// NOTE: the server's GET /admin/alert no longer accepts a `companyId` query param (removed in
// the company-scoping sweep — scope comes from the principal). We keep the `companyId`
// parameter for caller compatibility but no longer send it.
import {
    adminAlertControllerGetAll,
    adminAlertControllerDeleteAlert,
} from "../api/generated";

const throwAsAxiosError = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

export async function getAlerts(companyId) {
    const {data, error, response} = await adminAlertControllerGetAll({});
    if (error) throwAsAxiosError(error, response);
    return {data};
}

export async function deleteAlert(id) {
    const {data, error, response} = await adminAlertControllerDeleteAlert({path: {id}});
    if (error) throwAsAxiosError(error, response);
    return {data};
}
